export default "__VITE_ASSET__940c29e8__"